<template>
    <div v-if="product">
        <div class="card product border-0">
            <div class="product-image" v-bind:class="{ 'product-image-contain':product.subproduct_id }" v-bind:style="{ 'background-image': (product.thumbnail ? 'url('+product.thumbnail+')' : '') }">
                <div v-if="product.is_new" class="product-badge">{{ __('redeem.new') }}</div>
<!--                <img-->
<!--                    v-if="listIcon"-->
<!--                    :src="listIcon.url"-->
<!--                    :title="listIcon.text"-->
<!--                    style="max-width: 55px; position: absolute; bottom: 5px; left: 5px;"-->
<!--                    :style="{ left: (['miljo_bsci', 'miljo_oeko-tex'].includes(listIcon.name) ? '5px' : '-10px') }"-->
<!--                >-->
            </div>
            <div class="card-body">
                <div class="product-info">
                    <p class="product-preheader">{{ product.sub_title ?? '&nbsp;' }}</p>
                    <h6 class="product-header">
                        <span v-if="cart_item_qty > 1">{{cart_item_qty}} x </span>{{ product.title }}
                    </h6>
<!--                    <p class="product-subheader" v-if="sub_products.length === 0">{{ product.sub_title }}</p>-->
<!--                    <p class="product-subheader" v-if="sub_products.length > 0">{{ getSubproductTitles() }}</p>-->
                    <p v-if="points" class="product-price"><span v-if="cart_item_qty > 1">{{cart_item_qty}} x </span>{{ product.points }} {{ __('redeem.points') }}</p>
                    <p v-else-if="order" class="product-price"><span v-if="cart_item_qty > 1">{{cart_item_qty}} x </span>{{ product.price }} kr</p>
                    <div class="stock-status" v-if="!hide_stock">
                        <p v-if="product.phased_out" class="product-subheader" style="color: #e0ac13;">{{ __('redeem.product_is_phased_out') }}</p>
                        <p v-else-if="product.out_of_stock && product.block_purchase_until_date" class="product-subheader" style="color: #e0ac13;">{{ __('redeem.stock_status_out_of_stock') }} {{ product.block_purchase_until_date }}</p>
                        <p v-else-if="product.out_of_stock" class="product-subheader" style="color: #e0ac13;">{{ __('redeem.out_of_stock') }}</p>
                        <p v-else-if="product.is_non_stock_item" class="product-subheader" style="color: #27a227;">{{ __('redeem.16_days') }}</p>
                        <p v-else class="product-subheader" style="color: #27a227;">{{ __('redeem.stock_status_in_stock') }}</p>
                    </div>
                </div>
                <div style="display: flex; flex-direction: column; gap: 10px;">
                    <button v-if="!hide_buttons && !hide_info" type="button" class="btn btn-light btn-block btn-lg btn-info" @click="openModal" :id="'modal-label-product-'+uniqueId">{{ __('redeem.info') }}</button>
                    <div v-if="!hide_select && !hide_buttons && order">
                        <form v-if="selected" :action="'/'+__('redeem.current_langcode')+'/order/update'" method="POST">
                            <input type="hidden" name="_token" :value="csrf">
                            <input type="hidden" name="remove_item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                            <input v-if="product.subproduct_id" type="hidden" name="remove_subproduct_id" :value="product.subproduct_id">
                            <input type="number" min="0" step="1" class="form-control mb-2" v-model="currentQuantity">
                            <button type="submit" class="btn btn-primary btn-block btn-lg">{{ __('redeem.remove') }}</button>
                        </form>
                        <form v-else :action="'/'+__('redeem.current_langcode')+'/order/update'" method="POST">
                            <input type="hidden" name="_token" :value="csrf">
                            <input type="hidden" name="item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                            <input v-if="product.subproduct_id" type="hidden" name="media_item_id" :value="product.subproduct_id">
                            <button type="submit" class="btn btn-primary btn-block btn-lg">{{ __('redeem.buy') }}</button>
                        </form>
                    </div>
                    <div v-else-if="!hide_select && !hide_buttons">
                        <form :action="'/'+__('redeem.current_langcode')+'/redeem/update'" method="POST" ref="selectform">
                            <input type="hidden" name="_token" :value="csrf">

                            <div v-if="selected">
                                <input type="hidden" name="remove_item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                                <input v-if="product.subproduct_id && (product.type === 'pocket_pack' || product.type === 'poster') && selected" type="hidden" name="remove_subproduct_id" :value="product.subproduct_id">
                            </div>
                            <div v-else>
                                <input type="hidden" name="item_id" :value="(cart_item_id ? cart_item_id : getProductID())">
                                <input v-if="product.subproduct_id" type="hidden" name="media_item_id" :value="product.subproduct_id">
                            </div>

                            <div class="submit-button">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="chooseDisabled">{{ chooseText }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <product-info-modal
            ref="modal"
            :product="product"
            :size="((type==='pocket_pack' || type==='magazine_subscription') ? 'lg' : 'xl')"
            :choose-disabled="chooseDisabled"
            :hide-select="hide_select"
            :hide-buttons="hide_buttons"
            :selected="selected"
            :type="type"
            @select:gift="() => { if ($refs['selectform']) { $refs['selectform'].submit(); } }"
        ></product-info-modal>
    </div>
</template>

<script>
import ProductInfoModal from './ProductInfoModal.vue';

export default {
    components: {
        ProductInfoModal,
    },
    props: {
        product: {
            type: Object,
            default() {
                return {};
            },
        },
        sub_products: {
            type: Array,
            default() {
                return [];
            },
        },
        prod_id: {
            type: Number,
            default: null,
        },
        is_locked: {
            type: Number,
            default: 0,
        },
        type: {
            type: String,
            default: 'product',
        },
        testmode: {
            type: String,
            default: null,
        },
        cart_item_id: {
            type: String,
            default: null,
        },
        cart_item_qty: {
            type: Number,
            default: null,
        },
        points: {
            type: Boolean,
            default: false,
        },
        pointsLeft: {
            type: Number,
            default: 0,
        },
        order: {
            type: Boolean,
            default: false,
        },
        quantity: {
            type: Number,
            default: 1,
        },
        hide_buttons: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        is_out_of_stock: {
            type: Boolean,
            default: false,
        },
        mediaSelect: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }),
    methods: {
        openModal() {
            this.$refs.modal.open();
        },
        getProductID() {
            return this.product.id ? this.product.id : this.prod_id;
        },
        getSubproductTitles() {
            const titles = [];

            this.sub_products.forEach((product) => {
                titles.push(product.title);
            });

            return titles.join(', ');
        },
        isRedeemed() {
            return !!this.order;
        },
    },
    computed: {
        listIcon() {
            if (this.product && this.product.icons) {
                const miljoIcons = this.product.icons.filter((ico) => ico.category === 'Miljö');
                if (miljoIcons[0]) {
                    return miljoIcons[0];
                }
            }
            return null;
        },
        chooseText() {
            if (this.is_locked) {
                return this.__('redeem.locked_product');
            }
            if (this.selected) {
                return this.__('redeem.change_product');
            }
            if (this.testmode === 'TOT') {
                return this.__('redeem.choose');
            }
            if (this.product.phased_out) {
                return this.__('redeem.is_phased_out');
            }
            if (this.product.out_of_stock && (this.product.back_in_stock_date === null)) {
                return this.__('redeem.incoming');
            }
            return this.__('redeem.choose');
        },
        chooseDisabled() {
            if (this.is_locked) {
                return true;
            }
            if (this.selected) {
                return false;
            }
            if (this.product.phased_out) {
                return true;
            }
            if (this.points && !(this.pointsLeft >= this.product.points)) {
                return true;
            }
            if (this.testmode === 'TOT') {
                return false;
            }
            if (this.testmode === 'PRO') {
                return true;
            }
            if (this.product.out_of_stock && (this.product.back_in_stock_date === null)) {
                return true;
            }
            return false;
        },
        hide_stock() {
            // if (this.product.product_category_id === 1) {
            //     return false;
            // }

            // if (this.product.is_virtual) {
            //     return false;
            // }

            return this.type === 'pocket_pack'
                || this.type === 'magazine_subscription'
                || this.type === 'sfanytime_codes'
                || this.type === 'nextory_codes'
                || this.type === 'poster'
                || this.testmode === 'PRO'
                || this.testmode === 'TOT';
        },
        hide_select() {
            return this.testmode === 'PRO'
                || this.type === 'sfanytime_codes'
                || this.type === 'nextory_codes'
                || ((this.type === 'pocket_pack' || this.type === 'magazine_subscription' || this.type === 'poster') && !this.mediaSelect);
        },
        hide_info() {
            return this.type === 'sfanytime_codes'
                || this.type === 'nextory_codes'
                || ((this.type === 'pocket_pack' || this.type === 'magazine_subscription' || this.type === 'poster') && !this.mediaSelect);
        },
        uniqueId() {
            return this.product?.product_category_id + '-' + this.product.id + (this.product.subproduct_id ? '-' + this.product.subproduct_id : '');
        },
    },
};
</script>
